module.exports = "/images/iso-27001-logo.png?338bbd263996a94a9dc854ce2518f693";